@if (isMulti()) {
  <elcia-multi-dropdown
    [control]="control()"
    [items]="options()"
    [label]="'entity.timesheet-statuses' | translate"
    [textField]="'name'"
    [valueField]="'id'"
  />

} @else {

  <elcia-dropdown
    [control]="control()"
    [items]="options()"
    [label]="'entity.timesheet-status' | translate"
    [textField]="'name'"
    [valueField]="'id'"
  >
    <ng-template #item let-item>
      <div class="flex items-center gap-2">
        <elcia-dot [color]="item.color"/>
        <div>{{ item.name }}</div>
      </div>
    </ng-template>
  </elcia-dropdown>

}
